import CustomButton from '@/components/atoms/CustomButton';
import { RIGHT_ARROW_CHARACTER } from '@/constants/stringVars';
import { HStack, Text, VStack } from '@chakra-ui/react';

interface Props {
  title: string;
  timeStamp: string;
  message: string;
  isRead: boolean;
  CTALabel?: string;
  onCTAClick?: () => void;
}
const NotificationItemDisplay = ({ title, timeStamp, message, isRead, CTALabel, onCTAClick }: Props) => {
  return (
    <VStack width={'100%'} gap={'5px'} paddingY={'10px'}>
      <HStack justifyContent={'space-between'} width={'100%'} gap={'10px'}>
        <Text
          fontWeight={isRead ? 700 : 800}
          color={isRead ? 'text.mediumGray' : 'extra.orange'}
          fontSize={'12px'}
          lineHeight={'16px'}
          noOfLines={1}
        >
          {title}
          {/*  - {inView ? 'IN VIEW!!' : '_not_'} */}
        </Text>
        <Text
          fontWeight={isRead ? 500 : 600}
          color={'text.mediumGray'}
          fontSize={'14px'}
          lineHeight={'16px'}
          noOfLines={1}
        >
          {timeStamp}
        </Text>
      </HStack>

      <Text
        variant={'urbanistSemiBoldRegular'}
        width={'100%'}
        color={isRead ? 'text.mediumGray' : 'text.mediumBlue'}
        fontWeight={isRead ? 400 : 600}
        lineHeight={'16px'}
      >
        {message}
      </Text>

      {onCTAClick && (
        <HStack width={'100%'} align={'start'} marginTop={'4px'}>
          <CustomButton
            label={`${CTALabel}  ${RIGHT_ARROW_CHARACTER}`}
            onClick={onCTAClick}
            height={'18px'}
            labelColor={isRead ? 'text.mediumBlue' : 'primary.500'}
            style={{ padding: 0, border: 0 }}
            labelStyle={{ fontSize: '12px' }}
            isTransparent
          />
        </HStack>
      )}
    </VStack>
  );
};

export default NotificationItemDisplay;
